<template>
<div id="app">
<div v-if="isLoading" class="loading">Loading&#8230;</div> 

  <v-app id="inspire">
    <v-layout>
      <v-flex>

<div class="columns is-gapless is-mobile">
    <div class="column is-1"></div>
    <div @click="prev()" class="column is-1"><button class="button is-fullwidth is-white"><span class="icon is-medium"><i class="fas fa-angle-double-left"></i></span></button></div>
    <div @click="next()" class="column is-1"><button class="button is-fullwidth is-white"><span class="icon is-medium"><i class="fas fa-angle-double-right"></i></span></button></div>
    <div @click="prev()" class="column is-9"><button class="button is-white has-text-weight-bold">{{month_display}}</button></div>
</div>

     
 <!-- :height="return_height()" -->

        <v-sheet>
          <v-calendar
          ref="calendar"
          locale="fr"
          v-model="today"
            type="month"
            :value="today"
            color="primary"
            @click:day="(event)=>dateClick(event,true)"
          >
            <template v-slot:day="{ date }">
              <template v-for="event in eventsMap[date]">
                <v-menu
                  :key="event.id"
                  v-model="event.open"
                  full-width
                  offset-x
                >
                  <template v-slot:activator="{ on }">
                    <div
                      v-if="!event.time"
                      v-ripple
                      :class="return_event_class(event)"
                      v-on="on"
                      @click.stop
                      v-html="event.title"
                    ></div>
                  </template>
                  <v-card
                    color="grey lighten-4"
                    min-width="350px"
                    flat
                  >
                    <v-toolbar
                      :color="return_event_colour(event)"
                      dark>
                      <v-toolbar-title >{{event.course}}  <span class="is-size-7 has-text-right"><br>{{moment(event.date).format('Do MMM YY') }} </span> </v-toolbar-title>
                    </v-toolbar>
                    <v-card-title primary-title>
                       <span v-html="event.details"></span> 
<!-- <span>
                    <div class="columns is-multiline is-gapless">
                        <div class="column colBorderThin is-6 has-text-centered ">yosd</div>
                        <div class="column colBorderThin is-6">yo yo</div>
                        <div class="column is-12">yo yo yo</div>
                    </div>
</span> -->
                    </v-card-title>
                    <v-card-actions>
                      <v-btn 
                       outlined 
                        flat
                        color="black"
                      >
                        OK
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </template>
            </template>
          </v-calendar>
        </v-sheet>
      </v-flex>
    </v-layout>
  </v-app>
</div>
</template>

<script>
import moment from 'moment'
moment.locale('fr')

export default {
props: [ 'events', 'dtStart' ],

  name: 'app',

  data: () => ({
    //start: moment(),
    today: '', // moment(this.dtStart).format('YYYY-MM-DD'),
    month_display: '' , //moment().month(),
    selectedType: 'month',
    
    isLoading:false,
   
  }),

created() {
 
this.today = moment(this.dtStart).format('YYYY-MM-DD')

   //  this.start= moment(this.dtStart).format('YYYY-MM-DD')//moment(),
  //   this.today=  moment(this.dtStart).format('YYYY-MM-DD')

        var d = moment(this.today);
        d.month(); // 1
        this.month_display = d.format('MMM').toUpperCase() + ' ' + d.format('YYYY');
},

 

  computed: {
    // convert the list of events into a map of lists keyed by date
    eventsMap () {
      const map = {}
      this.events.forEach(e => (map[e.date] = map[e.date] || []).push(e))
      return map
    }
  },
  methods: {

return_height() {
    if (screen.width < 400) {
        return 450
    } else {
        return 600
    }

},

return_event_class(event){

    if (event.color == "red") {
       return 'eventTemplate eventEnd'
    } else if (event.color == "green") {
        return 'eventTemplate eventStart' 
    } else if (event.hour == "AM") {
        return 'eventTemplate eventAM' 
    }  else if (event.hour == "PM") {
        return 'eventTemplate eventPM' 
    } else  {
        return 'eventTemplate eventNormal'
    }

},
return_event_colour(event){
    if (event.color == "red") {
        return 'red'
    } else if (event.color == "green") {
        return 'green' 
    } else {
        return 'blue'
    }
},



      //  CALENDAR MONTH SWITCH +++++++++++++++++++++++++++++
      prev () {

        this.$refs.calendar.prev()
        var d = moment(this.today);
        d.month(); // 1
        this.month_display = d.format('MMM').toUpperCase() + ' ' + d.format('YYYY') ;
      },
      next () {
     

        this.$refs.calendar.next()
        var d = moment(this.today);
        d.month(); // 1
        this.month_display = d.format('MMM').toUpperCase() + ' ' + d.format('YYYY');

      },
      // +++++++++++++++++++++++++++++++++++++++++++++++++++++

/*     open (event) {
      alert(event.title)
    },
    dateClick(event,isAdd) {
      alert('date clicked - isAdd?'+isAdd)
      console.log(event);
    } */
  }
}
</script>

<style>

body, html, #app, #dayspan {
  font-family: Roboto, sans-serif !important;
  width: 100%;
  height: 100%;
}

.v-btn--flat,
.v-text-field--solo .v-input__slot {
  background-color: #f5f5f5 !important;
  margin-bottom: 8px !important;
}

.eventTemplate{
overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  width: 100%;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;  
}


.eventAM {
  background-color: #B0E0E6;
  color: Black;
  border: 1px solid #B0E0E6;
}
.eventPM {
  background-color: #00BFFF;
  color: Black;
  border: 1px solid #00BFFF;
}

.eventNormal {
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid #1867c0;
}
.eventEnd {

  background-color: red;
  color: #ffffff;
  border: 1px solid #1867c0;

}
.eventStart {

  background-color: green;
  color: #ffffff;
  border: 1px solid #1867c0;

}




</style>
